export default __webpack_public_path__ + "static/media/heroImage10.828cbe3f.webp";